import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitleNonFinal: {
		id: 'eoc-changeboarding.services.use-sync-devices.error-title-non-final',
		defaultMessage: "Couldn't update notification methods",
		description: 'Error message informing the user that updating the field failed',
	},
	errorDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-sync-devices.error-description-non-final',
		defaultMessage: 'Make sure your Jira Cloud mobile app is up-to-date, and try again.',
		description: 'Error message informing the user that updating the field failed',
	},
});
